import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class' ;
import { TICKET_MODULE_NAMESPACE, TICKET_SET_LOADER_STATE, TICKET_LOADERS } from '../../store/ticket';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_LOADERS } from '../../store/reception/reception-types.store';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_LOADERS } from '../../store/document';

const TicketStore= namespace(TICKET_MODULE_NAMESPACE)
const ReceptionStore= namespace(RECEPTION_MODULE_NAMESPACE)
const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)

@Component
class SearchSelectorComponent extends Vue {
  @Prop({ default: [], type: [Array] })
  items: { value: any, text: string }[]

  @Prop({ default: 'Sélectionner', type: [String] })
  label: string;
  @Prop({ default: 'Tapez quelque chose à filtrer', type: [String] })
  placeholder: string;
  @Prop({ default: 300, type: [Number] })
  debounce: number;
  @Prop({ default: true, type: [Boolean] })
  multiple: string;
  @Prop({ required: false, type: [Boolean, String] })
  clearable: boolean | string;
  @Prop({ required: false, type: [Boolean] })
  disabled: boolean;
  @Prop({ default:false, required: false, type: [Boolean] })
  readonly: boolean;
  @Prop({ required: false, type: [Boolean] })
  clearAfterSelecting: boolean;
  @Prop({ default: () => [] })
  value: any[];
  @Prop({ default: () => ({}), type: [Function] })
  onFetch: Function;
  @Prop({ type: [Object, Array] })
  rules: any;
  @Prop({ type: [Array] })
  mainFilter: number[]
  dtLoading: boolean | null;
  dtSearch: string | null;
  dtOptions: { value: any, text: string }[]
  dtSelectedOptions: { value: any, text: string }[]

  @Prop({ default: () => ({}), type: [Function] })
  onChange: Function;

  @Prop({ default: () => ({}), type: [Function] })
  setLoaderState: Function

  /**
   *
   */
  constructor () {
    super()
    this.dtSearch = null
    this.dtLoading = false
    this.dtOptions = this.items
    this.dtSelectedOptions=[]
  }

  @TicketStore.Getter('loaders') ticket_loaders: Map<string,boolean>
  @ReceptionStore.Getter('loaders') reception_loaders: Map<string,boolean>
  @DocumentStore.Getter('loaders') document_loaders: Map<string,boolean>

  @TicketStore.Mutation(TICKET_SET_LOADER_STATE)
  storeSetTicketLoaderState: ( payload?: { key: string, value: boolean }) => void

  get coRules () {
    if (this.disabled) {
      return undefined
    }
    return this.rules
  }
  get coClearable (): boolean {
    return Boolean(this.clearable)
  }
  get hasProps (): boolean {
    return Object.keys(this.$slots).length > 1
  }
  get vModel (): any[] {
    return this.value
  }

  set vModel (val: any[]) {
    const options= [...this.dtOptions]
    this.dtSelectedOptions= this.dtSelectedOptions.filter(item => (val as any).includes(item.value))
    const valObject=  options.filter(item => (val as any).includes(item.value))
    this.dtSelectedOptions= [...this.dtSelectedOptions,...valObject]
    this.$emit('input', val)
  }
  get coOptions (): { value: any, text: string }[] {
    return [...this.dtOptions, ...this.dtSelectedOptions]
  }

  get extendItemCount (): number {
    return this.vModel.length - 1
  }

  get coLoader(): boolean {
    return this.ticket_loaders.get(TICKET_LOADERS.LIST_FILTERS)
          || this.reception_loaders.get(RECEPTION_LOADERS.FILTERS)
          || this.document_loaders.get(DOCUMENT_LOADERS.FILTERS_LOADER)
  }

  getVisibility (index: number): boolean {
    return this.vModel && (index === this.vModel.length - 1)
  }
  _clearTimeout: any;
  async handleFilter (event: any) {
    const filterOptions= x => x.text.toLocaleLowerCase().match(this.dtSearch.toLocaleLowerCase())
    if (this.dtSearch) {
      this.dtOptions = this.items.filter(filterOptions)
    }
    if (this.onFetch) {
      await this.handleRemoteFilter()
    }
  }

  callback (data) {
    if (data) {
      this.dtLoading = false
      if (this.clearAfterSelecting) {
        this.dtSearch = ''
      }
      this.dtOptions = [...this.dtOptions, ...data]
    }
  }
  async handleRemoteFilter () {
    if (this.onFetch) { this.dtLoading = true }
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.onFetch(this.dtSearch, this.callback, (loading) => {
        this.dtLoading = loading || false
        if(this.coLoader) {
          this.setLoaderState(false)
        }
      })
    }, this.debounce)
  }
  mounted () {
    this.$nextTick(() => {
      this.dtOptions = this.items
    })

    this.setLoaderState(true)
    this.handleFilter(null)
    this.$watch('items', async (n, o) => {
      if(this.mainFilter && this.mainFilter.length) {
        this.dtSelectedOptions=[]
        this.dtOptions= n
      }
    })
  }
}

export default SearchSelectorComponent



// WEBPACK FOOTER //
// ./src/components/condition-selector/index.ts